module.exports = __webpack_public_path__ + "img/time-for-tao.44098621.png";